
import { useContext, useState, ChangeEvent } from 'react'
import { AuthSelector, setShowModalChangePass, postChangePassWord } from '../../store/reducers/auth/auth'
import { useSelector, useDispatch } from 'react-redux'
import { ConstContext } from '../../store/context/constContext'
import { Button, Modal, Checkbox, Form, Input } from 'antd';

const ChangePassWord = () => {
    // Contexts
    const {
        setShowToast
    } = useContext(ConstContext)

    const distpatch = useDispatch()
    const AuthSelectors = useSelector(AuthSelector)
    // State
    const [newPost, setNewPost] = useState({
        Code: AuthSelectors.user ? AuthSelectors.user.Code : '',
        OldPassWord: '',
        NewPassWord: '',
        ReNewPassWord: ''
    })
    const { Code, OldPassWord, NewPassWord, ReNewPassWord } = newPost

    const onChangeNewPostForm = (event) =>
        setNewPost({ ...newPost, [event.target.name]: event.target.value })

    const closeDialog = () => {
        resetAddPostData()
    }

    const onSubmit = async () => {
        if (NewPassWord !== ReNewPassWord) {
            setShowToast({ show: true, message: 'Mật khẩu mới không khớp!', type: 'danger' })
            return
        }

        const rs = await distpatch(postChangePassWord(newPost)).then(((res) => {
            if (!res.payload.success) {
                setShowToast({ show: true, message: res.payload.message || "Đổi mật khẩu thất bại", type: 'danger' })
                return
            }
            resetAddPostData()
            setShowToast({ show: true, message: "Đổi mật khẩu thành công", type: 'success' })
        }))

    }

    const resetAddPostData = () => {
        setNewPost({ ...newPost, OldPassWord: '', NewPassWord: '', ReNewPassWord: '' })
        distpatch(setShowModalChangePass(false))
    }

    return (
        <Modal title="Đổi mật khẩu" visible={AuthSelectors.showModalChangePass} onOk={onSubmit} onCancel={closeDialog} width={600}>
            <Form
                name="basic"
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}
                initialValues={{ remember: true }}
                autoComplete="off"
            >
                <Form.Item
                    label="Mật khẩu cũ"
                    name="OldPassWord"
                    rules={[{ required: true, message: 'Vui lòng nhật mật khẩu cũ!' }]}
                >
                    <Input.Password
                        placeholder='Mật khẩu cũ'
                        name='OldPassWord'
                        required
                        aria-describedby='title-help'
                        value={OldPassWord}
                        onChange={onChangeNewPostForm}
                    />
                </Form.Item>

                <Form.Item
                    label="Mật khẩu mới"
                    name="NewPassWord"
                    rules={[{ required: true, message: 'Vui lòng nhập mật khẩu mới!' }]}
                >
                    <Input.Password
                        placeholder='Mật khẩu mới'
                        name='NewPassWord'
                        required
                        aria-describedby='title-help'
                        value={NewPassWord}
                        onChange={onChangeNewPostForm}
                    />
                </Form.Item>
                <Form.Item
                    label="Nhập lại mật khẩu mới"
                    name="ReNewPassWord"
                    rules={[{ required: true, message: 'Vui lòng nhập lại mật khẩu!' }]}
                >
                    <Input.Password
                       placeholder='Nhập lại mật khẩu mới'
                       name='ReNewPassWord'
                       required
                       aria-describedby='title-help'
                       value={ReNewPassWord}
                       onChange={onChangeNewPostForm}
                    />
                </Form.Item>
            </Form>
        </Modal>


    )

}

export default ChangePassWord